export * from './dist/accessibility';


//////////////////
// WEBPACK FOOTER
// ./~/accessibility/index.js
// module id = /qkq
// module chunks = 16